import MUIAlert from '@mui/material/Alert'
import MUISnackbar from '@mui/material/Snackbar'
export type ISnackBarLevel = 'success' | 'error' | 'warning' | 'info'
export type ISnackBarDuration = 'short' | 'medium' | 'long'
interface ISnackBarProps {
  open: boolean
  message: string
  onClose: () => void
  level?: ISnackBarLevel
  duration?: ISnackBarDuration
}
const DURATION_MAP: Record<ISnackBarDuration, number> = {
  short: 6000,
  medium: 10000,
  long: 15000,
}
export default function SnackBar({ open, message, onClose, level, duration = 'short' }: ISnackBarProps) {
  return (
    <MUISnackbar open={open} autoHideDuration={DURATION_MAP[duration]} onClose={onClose} message={message}>
      <div>
        <MUIAlert severity={level} onClose={onClose} sx={{ width: '100%' }}>
          {message}
        </MUIAlert>
      </div>
    </MUISnackbar>
  )
}
